import { render, staticRenderFns } from "./StockOpnameDetails.vue?vue&type=template&id=277e1c2b&"
import script from "./StockOpnameDetails.vue?vue&type=script&lang=js&"
export * from "./StockOpnameDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports